import { useEffect } from "react";

// Domo's notifyFrameSize only measures its card grid. Its embed page also renders a header (47px filter/share
// toolbar, plus a 48px page title when the page shows one) and 40px of layout padding, none of which is reported.
const DOMO_FRAME_CHROME_HEIGHT = 140;

// Reads the full content height from the size messages embedded pages post to their parent.
// Add other providers' size messages here.
const getReportedFrameHeight = (data) => {
  if (data?.method === "notifyFrameSize") {
    const height = Number(data.params?.height);
    return height > 0 ? height + DOMO_FRAME_CHROME_HEIGHT : null;
  }

  return null;
};

// Grows any iframe inside the container to the content height its page reports, so the portal scrolls instead
// of the iframe. Embedded pages that scroll internally can clip their own bottom edge (Domo does); iframes that
// never report a height keep filling the available space.
const useIframeAutoHeight = ({ containerRef, workspaceDetails, site }) => {
  const disabledIframeExpansion = workspaceDetails?.use_global_settings ? site?.disabled_iframe_expansion : workspaceDetails?.disabled_iframe_expansion;

  useEffect(() => {
    if (disabledIframeExpansion) return;

    const handleMessage = (event) => {
      const height = getReportedFrameHeight(event.data);
      if (!height) return;

      const iframe = [...(containerRef.current?.querySelectorAll("iframe") || [])].find((frame) => frame.contentWindow === event.source);
      if (iframe) {
        iframe.style.minHeight = `${Math.ceil(height)}px`;
      }
    };

    window.addEventListener("message", handleMessage, { passive: true });
    return () => window.removeEventListener("message", handleMessage);
  }, [containerRef, disabledIframeExpansion]);
};

export default useIframeAutoHeight;
